import {
    GET_EXITS,
    GET_EXITS_SUCCESS,
    GET_HATCH_EXITS_PARAM,
    GET_HATCH_EXITS
} from './constants';

/**
 *
 * @param quizID
 * @returns {{quizID: *, type: string}}
 */
const statisticsExits = ( quizID, params ) => ( { type: GET_EXITS, quizID, params } );

const statisticsHatchExits = hatchID => ( { type: GET_HATCH_EXITS, hatchID } );
const statisticsHatchExitsParams = ( hatchID, params ) => ( { type: GET_HATCH_EXITS_PARAM, hatchID, params } );

/**
 *
 * @param exits
 * @returns {{exits: *, type: string}}
 */
const statisticsExitsSuccess = exits => ( { type: GET_EXITS_SUCCESS, exits } );

export {
    statisticsExits,
    statisticsHatchExits,
    statisticsExitsSuccess,
    statisticsHatchExitsParams
};